<template>
   <div class="paas-list-container">
    <div class="paas-tree-list-container ivu-col-span-12">
      <div class="paas-tree-content" v-height="{height: -10}">
        <v-tree ref='paasTree' :data='paasTreeData' :multiple='true' :expanded="true"/>
      </div>
    </div>
     <div class="paas-tree-select-oper ivu-col-span-10">
       <Button type="primary" class="paas-oper-btn" icon="md-checkmark" @click="paasSelectSaveData">保存</Button>
     </div>
  </div>
</template>

<script>
  import { getTreeData } from "@api/admin.js";
  export default {
    props: {
      funcData: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    data() {
      return {
        serviceUrl: "/sys/func",
        currentIdFiledName: 'id',
        paasTreeData: [],
        queryParam:{}
      }
    },
    methods: {
      queryTableData() {
        getTreeData(this.serviceUrl, this.queryParam).then(res=> {
          ;
          if(res.code === 200) {
            this.paasTreeData = res.data;
            this.$refs.paasTree.setTreeNodesAttr(this.paasTreeData, "expanded", true);
          }
        }).catch(error=>{
          ;
          this.$Message.error('数据查询失败，请重试！');
        });
      },
      paasSelectSaveData() {
        let nodes = this.$refs.paasTree.getCheckedNodes();
        this.$emit("save", nodes);
      }
    },
    created: function() {
      this.queryTableData();
    },
    watch: {
      funcData(curVal,oldVal){
        this.$refs.paasTree.setTreeNodesAttr(this.paasTreeData, "checked", false);
        this.$refs.paasTree.setTreeNodesAttr(this.paasTreeData, "expanded", true);
        if(curVal && curVal.length > 0) {
          for(let j = 0; j < curVal.length; j++) {
            this.$refs.paasTree.setTreeNodeAttr(curVal[j], "checked", true);
          }
        }
      }
    }
  }
</script>

<style scoped>
  @import '../../../assets/css/paas/paas-list.css';
  @import '../../../assets/css/paas/paas-edit.css';
  .paas-form-wrap-normal {
    margin-top: 10px;
  }
  .paas-tree-select-oper {
    margin-top: 10px;
    padding-left: 20px;
  }
</style>
